<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <button
    :class="b('', { view })"
    :disabled="notVerified"
    v-tooltip="
      notVerified
        ? $t('Для получения доступа пройдите процедуру верификации')
        : null
    "
  >
    <slot name="icon-left"></slot>
    <span :class="b('label')">
      <slot name="label"></slot>
    </span>
  </button>
</template>
